import { render, staticRenderFns } from "./QSummitHomePageRoadmap.vue?vue&type=template&id=2bc96703&"
import script from "./QSummitHomePageRoadmap.vue?vue&type=script&lang=js&"
export * from "./QSummitHomePageRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./QSummitHomePageRoadmap.vue?vue&type=style&index=0&id=2bc96703&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports